export enum TestState {
  RECOLLECT = 'Recollect',
  RECOLLECT_PENDING = 'RecollectPending',
}
